import React from 'react';

const PreparedProjects = ({projects = []}) => {
    return (
        <>
            {projects.length > 0 && (
                <div style={{marginTop: 50}}>
                    <h1>회원님을 위해 미리 생성 된 아래 프로젝트와 연결되었습니다.</h1>
                    {projects.map((el, idx) => (
                        <p key={idx}>{`${el.title}, 주소: ${el.address}`}</p>
                    ))}
                </div>
            )}
        </>
    )
}

export default PreparedProjects;


// WEBPACK FOOTER //
// ./Src/Components/User/PreparedProjects.js